<link rel="stylesheet"
      href="https://openlayers.org/en/v5.3.0/css/ol.css"
      type="text/css">

<div class="container-fluid"
    [ngClass]="{'sb-open' : rightSBarOpened && mapWidthType === 'small',
    'sb-open-sidebar-large': rightSBarOpened && mapWidthType === 'large'}"
     >

  <div class="row">
    <div class="col p-0">

      <div class="torna-pagina"
           [hidden]="!showBackButton">
        <button type="button"
                class="btn bg-blu txt-white"
                placement="bottom"
                ngbTooltip="Torna alla pagina di ricerca"
                (click)="onBackButtonClick();">
          Torna alla pagina di ricerca
        </button>
      </div>
      <div class="position-relative map-dim"
          [ngStyle]="altezza"
          [ngClass]="{'sb-open-content' : rightSBarOpened && mapWidthType === 'small',
          'sb-open-content-sidebar-large': rightSBarOpened && mapWidthType === 'large'}"
        >

           <!-- [larghezzaSidebar]="500" -->
        <ebw-map [login]="login"
                 [options]="options"
                 [configMappa]="configMappa"
                 [idStileSelezione]="configMappa.selezioneSetup.stile"
                 [idStileDisegno]="configMappa.disegnoSetup.stile"
                 [stiliConfigurazione]="configMappa.styles"
                 [iconaIndirizzoSelezionato]="'assets/resources/marker50.png'"
                 [larghezzaSidebar]="larghezzaSidebar"
                 [token]="loginService.getToken()"
                 [payLoad]="userService.userGetProperties()"
                 (mappaPronta)="onMapReady()"
                 (chiusuraOggettoSelezionatoEmitter)="chiudiObj($event)"
                 (modificaOggettoSelezionatoEmitter)="modificaObj($event)"
                 (visualizzaInfoOggettoSelezionatoEmitter)="visualizzaObj($event)"
                 (toolDisegnoElementoConfermatoMapEmitter)="gestisciElementoConfermato($event)"
                 (chiudiToolDisegnoMapEmitter)="gestisciChiusuraToolDisegno($event)"
                 (mapSidebarStateEmitter)="handleMapSidebar($event)"
                 #mappa>
        </ebw-map>
      </div>
    </div>
  </div>
</div>

<!-- <div class="right-map-sidebar" *ngIf="rightMenuEnabled" 
     [class.sb-close]="!rightSBarOpened"> 
  <router-outlet></router-outlet>
</div> -->

<div 
  *ngIf="rightMenuEnabled"
  [ngStyle]="rightSidebarSize"
  [class.sb-close]="!rightSBarOpened"
  class="right-map-sidebar">
  <router-outlet></router-outlet>
</div>

<app-select-popup *ngIf="mappa._mappaPronta"></app-select-popup>